export default __webpack_public_path__ + "96cc3baa24eb4e2e9d2946b755bd7d8d.png";